import { useState } from 'react';

import { motion } from 'framer-motion';

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Flex,
  Icon,
  Box,
  Tooltip,
} from '@chakra-ui/react';

import ValidationMessage from 'components/validation/ValidationMessage';

import getValidationMessage from 'helpers/getValidationMessage';

import { MdChevronRight } from 'react-icons/md';

const MotionAlert = motion(Alert);

const ValidationItem = ({ validation }: { validation: Validation }) => {
  const [isOpen, setIsOpen] = useState(
    validation.validation_outcome !== 'pass',
  );

  const {
    validation_id,
    validation_outcome,
    validation_name,
    description,
    validation_type,
  } = validation;

  const caution = '#ffda87';
  const fail = '#f8a586';
  const pass = '#badeb5';

  const outcomeColor =
    validation_outcome === 'pass'
      ? pass
      : validation_outcome === 'caution'
      ? caution
      : fail;

  const alertStatus =
    validation_outcome === 'pass'
      ? 'success'
      : validation_outcome === 'caution'
      ? 'warning'
      : 'error';

  return (
    <Box key={validation_id}>
      <Tooltip
        label={validation_type === 'non-target' ? 'Non-target' : ''}
        placement="top"
        hasArrow
      >
        <Alert
          backgroundColor={outcomeColor}
          status={alertStatus}
          variant="solid"
          borderRadius="8px"
          onClick={() => setIsOpen(!isOpen)}
          cursor="pointer"
          _hover={{ opacity: 0.9 }}
        >
          {validation_type === 'non-target' &&
            validation_outcome !== 'pass' && <AlertIcon color="#59606A" />}

          <AlertTitle color="#59606A" mr="12px">
            {validation_outcome.charAt(0).toUpperCase() +
              validation_outcome.slice(1)}
          </AlertTitle>
          <AlertDescription color="#59606A" isTruncated>
            {validation_name}
          </AlertDescription>
          <Icon
            as={MdChevronRight}
            color="#59606A"
            h="30px"
            w="30px"
            position="absolute"
            right="10px"
            top="9px"
            transform={isOpen ? 'rotate(90deg)' : 'rotate(0deg)'}
            transition="transform 0.3s ease-in-out"
          />
        </Alert>
      </Tooltip>

      {isOpen && (
        <MotionAlert
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8 }}
          borderRadius="8px"
          status={alertStatus}
          backgroundColor={
            validation_outcome === 'pass'
              ? '#EBF0EB'
              : validation_outcome === 'caution'
              ? '#fffbe5'
              : '#ffe1d5'
          }
          mt="1rem"
        >
          <Flex>
            <AlertIcon color={outcomeColor} />
            <Flex direction="column">
              <AlertTitle
                color="#59606A"
                mr="12px"
                fontWeight="700"
                mb={alertStatus === 'success' ? '0' : '10px'}
              >
                {description}
              </AlertTitle>

              <AlertDescription color="#59606A" fontWeight={500}>
                <ValidationMessage
                  message={getValidationMessage(validation)}
                  boldFirst={false}
                />
              </AlertDescription>
            </Flex>
          </Flex>
        </MotionAlert>
      )}
    </Box>
  );
};

export default ValidationItem;
